import { Box } from 'grommet';
import { useRouter } from 'next/router';
import React, { useContext, useState } from 'react';
import { handleErrors } from '../../../utils/errors';
import Drawer from '../../Drawer';
import Loading from '../../Loading';
import { NotificationsContext } from '../../NotificationsProvider';
import RecordJournalEntry from './RecordJournalEntry';

const AddTransactionDrawer = ({
    type: initialType,
    onClose,
    defaultCustomer,
    defaultCustomerIsGroup,
    defaultInvoice,
    customerId,
    onSuccess
}) => {
    const router = useRouter();
    const notificationCtx = useContext(NotificationsContext);
    const [isCreating, setIsCreating] = useState(false);
    const [selectedType, setSelectedType] = useState(initialType || 'external-payment');

    const addTransaction = ({ value, callback, onErrorCallback }) => {
        const { memo_content, ...rest } = value;
        const body = {
            ...rest,
            ...(memo_content ? { memo: { content: memo_content } } : {}),
        };
        fetch('/api/transactions/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }).then(handleErrors)
            .then(data => callback && callback(data))
            .then(notificationCtx.showNotification)
            .catch((data)=> {
                notificationCtx.showNotification(data)
                onErrorCallback && onErrorCallback();
            })
            .catch(() => callback && callback());
    };

    const title = () => {
        if (selectedType === 'external-payment') return 'Record External Payment';
        if (selectedType === 'credit-note') return 'Record Credit Note';
        if (selectedType === 'debit-note') return 'Record Debit Note';
        return 'Record Transaction';
    };

    return (
        <Drawer
            title={title()}
            onClose={onClose}
        >
            { isCreating ? (
                <Box align="center" margin="small">
                    <Loading/>
                </Box>
            ) : (
                <RecordJournalEntry
                    entryType={selectedType}
                    customerId={customerId}
                    defaultCustomer={defaultCustomer}
                    defaultInvoice={defaultInvoice}
                    defaultCustomerIsGroup={defaultCustomerIsGroup}
                    onTypeChange={setSelectedType}
                    onSubmit={(event) => {
                        setIsCreating(true);
                        addTransaction({
                            value: event.value,
                            callback: () => {
                                onSuccess && onSuccess();
                                onClose && onClose();
                                setIsCreating(false);
                            },
                            onErrorCallback: () => {
                                setIsCreating(false);
                            }
                        });
                    }}
                    onCancel={onClose || router.back}
                />
            )}
        </Drawer>
    );
}

export default AddTransactionDrawer;
